(function () {
  'use strict';
  var root = document.querySelector('[data-currency-selector]');
  if (!root) return;
  var select = root.querySelector('[data-currency-select]');
  var form = root.querySelector('#CurrencyLocalizationForm');
  if (!select || !form) return;
  select.addEventListener('change', function () {
    if (select.value) form.submit();
  });
})();
